import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { NoPermission } from '../design-system/NoPermission';

export default function PartnerRoute({ children, token, authLoading }) {
    const { decodedUser } = useAuth();
    const location = useLocation();

    if (authLoading) {
        return (
            <div className="flex items-center justify-center min-h-[60vh]">
                <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-orange-500" />
            </div>
        );
    }

    if (!token) {
        return <Navigate to="/partner/login" state={{ from: location }} replace />;
    }

    const role = decodedUser?.type || '';
    const isPartner = role === 'partner' || role === 'admin' || role === 'super_admin';

    if (!isPartner) {
        return (
            <NoPermission
                role="partner"
                message="Only registered trek operators can access the partner dashboard."
                actionLabel="Back to Home"
                actionTo="/"
            />
        );
    }

    return children;
}
